import { BigNum } from '@drift-labs/sdk';
import { ENUM_UTILS, MarketId } from '@drift/common';
import React from 'react';
import SkeletonValuePlaceholder from 'src/components/SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import NumberDisplay from '../Utils/NumberDisplay';

const priceChangePercentDisplay = (props: {
	marketId: MarketId;
	markPrice: BigNum;
}) => {
	const marketData24h = useDriftStore((s) => s.marketsData24H);

	let pricePercentChange = undefined;

	const dataForMarket = marketData24h.find(
		(mkt) =>
			ENUM_UTILS.match(mkt.marketType, props.marketId.marketType) &&
			mkt.marketIndex == props.marketId.marketIndex
	);

	const price24hAgo = dataForMarket?.price24hAgo || 0;
	const markPrice = props?.markPrice?.toNum() || 0;

	pricePercentChange =
		markPrice && price24hAgo
			? 100 * ((markPrice - price24hAgo) / price24hAgo)
			: 0;

	return pricePercentChange == undefined ? (
		<SkeletonValuePlaceholder
			className="xs:h-[11px] sm:h-[20px] my-[1px]"
			loading={true}
		/>
	) : (
		<NumberDisplay
			value={pricePercentChange}
			displayType="percentageChange"
			colourCoded
		/>
	);
};

export const PriceChangePercentDisplay = React.memo(priceChangePercentDisplay);
